// Team Icons Library

import {
  Users,
  Shield,
  Code,
  Settings,
  Package,
  ShieldCheck,
  Wrench,
  Briefcase,
  Building,
  Building2,
  Rocket,
  Target,
  Trophy,
  Star,
  Heart,
  Zap,
  Flame,
  Crown,
  Award,
  Medal,
  Flag,
  Compass,
  Map,
  Globe,
  Laptop,
  Monitor,
  Smartphone,
  Tablet,
  Database,
  Server,
  Cloud,
  HardDrive,
  Cpu,
  Wifi,
  Radio,
  Bluetooth,
  Headphones,
  Mic,
  Camera,
  Video,
  Film,
  Image,
  FileText,
  File,
  Folder,
  FolderOpen,
  Archive,
  Bookmark,
  Tag,
  Hash,
  AtSign,
  Mail,
  Send,
  MessageCircle,
  MessageSquare,
  Phone,
  PhoneCall,
  Bell,
  Calendar,
  Clock,
  Timer,
  Hourglass,
  Watch,
  AlarmClock,
  Sun,
  Moon,
  CloudRain,
  CloudSnow,
  Wind,
  Umbrella,
  Thermometer,
  Activity,
  TrendingUp,
  TrendingDown,
  BarChart,
  BarChart2,
  BarChart3,
  PieChart,
  LineChart,
  GitBranch,
  GitCommit,
  GitMerge,
  GitPullRequest,
  Github,
  Gitlab,
  Terminal,
  Command,
  Box,
  Boxes,
  Container,
  Layers,
  Layout,
  Grid,
  Columns,
  Square,
  Circle,
  Triangle,
  Hexagon,
  Pentagon,
  Octagon,
  Diamond,
  Plus,
  Minus,
  X,
  Check,
  CheckCircle,
  XCircle,
  AlertCircle,
  AlertTriangle,
  Info,
  HelpCircle,
  Search,
  Filter,
  SlidersHorizontal,
  Edit,
  Edit2,
  Edit3,
  Save,
  Copy,
  Clipboard,
  Scissors,
  Trash,
  Trash2,
  Download,
  Upload,
  Share,
  Share2,
  Link,
  Link2,
  ExternalLink,
  Eye,
  EyeOff,
  Lock,
  Unlock,
  Key,
  UserCheck,
  UserPlus,
  UserMinus,
  UserX,
  Home,
  Inbox,
  ShoppingCart,
  ShoppingBag,
  CreditCard,
  PoundSterling,
  Percent,
  Music,
  Volume,
  Volume1,
  Volume2,
  VolumeX,
  Play,
  Pause,
  SkipBack,
  SkipForward,
  FastForward,
  Rewind,
  Repeat,
  Shuffle,
  Maximize,
  Minimize,
  ZoomIn,
  ZoomOut,
  Move,
  Navigation,
  Navigation2,
  MapPin,
  Locate,
  Crosshair,
  Anchor,
  Plane,
  Car,
  Bike,
  Bus,
  Train,
  Truck,
  Ship,
  Mountain,
  TreePine,
  Flower,
  Leaf,
  Feather,
  Bug,
  Lightbulb,
  Flashlight,
  Battery,
  BatteryCharging,
  Plug,
  Power,
  PowerOff,
  Printer,
  Scan,
  QrCode,
  Barcode,
  Fingerprint,
  Gauge,
  Sliders,
  ToggleLeft,
  ToggleRight,
  Maximize2,
  Minimize2,
  CornerUpLeft,
  CornerUpRight,
  CornerDownLeft,
  CornerDownRight,
  ArrowUp,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ChevronUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsUp,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  Menu,
  MoreHorizontal,
  MoreVertical,
  Grip,
  GripVertical,
  Aperture,
  Focus,
  Disc,
  Tv,
  Gamepad,
  Gamepad2,
  Puzzle,
  Paintbrush,
  Palette,
  Pipette,
  Ruler,
  Pen,
  PenTool,
  Eraser,
  Type,
  Bold,
  Italic,
  Underline,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  List,
  ListOrdered,
  Indent,
  Outdent,
  Quote,
  Code2,
  Braces,
  Binary,
  FileCode,
  Webhook,
  Workflow,
  GitGraph,
  Network,
  Rss,
  Signal,
  Antenna,
  Radar,
  Waves,
  Fan,
  Snowflake,
  Droplet,
  Droplets,
  CloudDrizzle,
  CloudLightning,
  Sunrise,
  Sunset,
  Sparkles,
  Orbit,
  Atom,
  Dna,
  Microscope,
  TestTube,
  Beaker,
  Pill,
  Syringe,
  Stethoscope,
  Bandage,
  HeartPulse,
  Brain,
  Bone,
  Skull,
  Coffee,
  Beer,
  Wine,
  Pizza,
  Cake,
  Cookie,
  Apple,
  Cherry,
  Grape,
  Banana,
  Carrot,
  Egg,
  Fish,
  Beef,
  Soup,
  Utensils,
  UtensilsCrossed,
  ChefHat,
  Lamp,
  Sofa,
  Bed,
  Bath,
  Shirt,
  Glasses,
  Gem,
  Gift,
  PartyPopper,
  Sparkle,
  Wand,
  Wand2,
  Dice1,
  Dice2,
  Dice3,
  Dice4,
  Dice5,
  Dice6,
  Spade,
  Club,
  ThumbsUp,
  ThumbsDown,
  Smile,
  Frown,
  Meh,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface TeamIcon {
  name: string;
  icon: LucideIcon;
  category: string;
}

export const TEAM_ICONS: TeamIcon[] = [
  // People & Teams
  { name: 'Users', icon: Users, category: 'People & Teams' },
  { name: 'User Check', icon: UserCheck, category: 'People & Teams' },
  { name: 'User Plus', icon: UserPlus, category: 'People & Teams' },
  { name: 'User Minus', icon: UserMinus, category: 'People & Teams' },
  { name: 'User X', icon: UserX, category: 'People & Teams' },

  // Security & Protection
  { name: 'Shield', icon: Shield, category: 'Security & Protection' },
  { name: 'Shield Check', icon: ShieldCheck, category: 'Security & Protection' },
  { name: 'Lock', icon: Lock, category: 'Security & Protection' },
  { name: 'Unlock', icon: Unlock, category: 'Security & Protection' },
  { name: 'Key', icon: Key, category: 'Security & Protection' },
  { name: 'Eye', icon: Eye, category: 'Security & Protection' },
  { name: 'Eye Off', icon: EyeOff, category: 'Security & Protection' },
  { name: 'Fingerprint', icon: Fingerprint, category: 'Security & Protection' },

  // Development & Code
  { name: 'Code', icon: Code, category: 'Development & Code' },
  { name: 'Code 2', icon: Code2, category: 'Development & Code' },
  { name: 'Terminal', icon: Terminal, category: 'Development & Code' },
  { name: 'Command', icon: Command, category: 'Development & Code' },
  { name: 'Git Branch', icon: GitBranch, category: 'Development & Code' },
  { name: 'Git Commit', icon: GitCommit, category: 'Development & Code' },
  { name: 'Git Merge', icon: GitMerge, category: 'Development & Code' },
  { name: 'Git Pull Request', icon: GitPullRequest, category: 'Development & Code' },
  { name: 'Git Graph', icon: GitGraph, category: 'Development & Code' },
  { name: 'Github', icon: Github, category: 'Development & Code' },
  { name: 'Gitlab', icon: Gitlab, category: 'Development & Code' },
  { name: 'Braces', icon: Braces, category: 'Development & Code' },
  { name: 'Binary', icon: Binary, category: 'Development & Code' },
  { name: 'File Code', icon: FileCode, category: 'Development & Code' },
  { name: 'Webhook', icon: Webhook, category: 'Development & Code' },
  { name: 'Workflow', icon: Workflow, category: 'Development & Code' },

  // Business & Office
  { name: 'Briefcase', icon: Briefcase, category: 'Business & Office' },
  { name: 'Building', icon: Building, category: 'Business & Office' },
  { name: 'Building 2', icon: Building2, category: 'Business & Office' },
  { name: 'Settings', icon: Settings, category: 'Business & Office' },
  { name: 'Wrench', icon: Wrench, category: 'Business & Office' },
  { name: 'Package', icon: Package, category: 'Business & Office' },
  { name: 'Box', icon: Box, category: 'Business & Office' },
  { name: 'Boxes', icon: Boxes, category: 'Business & Office' },
  { name: 'Container', icon: Container, category: 'Business & Office' },
  { name: 'Archive', icon: Archive, category: 'Business & Office' },
  { name: 'Inbox', icon: Inbox, category: 'Business & Office' },
  { name: 'Shopping Cart', icon: ShoppingCart, category: 'Business & Office' },
  { name: 'Shopping Bag', icon: ShoppingBag, category: 'Business & Office' },
  { name: 'Credit Card', icon: CreditCard, category: 'Business & Office' },
  { name: 'Pound Sterling', icon: PoundSterling, category: 'Business & Office' },
  { name: 'Percent', icon: Percent, category: 'Business & Office' },

  // Achievement & Success
  { name: 'Rocket', icon: Rocket, category: 'Achievement & Success' },
  { name: 'Target', icon: Target, category: 'Achievement & Success' },
  { name: 'Trophy', icon: Trophy, category: 'Achievement & Success' },
  { name: 'Star', icon: Star, category: 'Achievement & Success' },
  { name: 'Award', icon: Award, category: 'Achievement & Success' },
  { name: 'Medal', icon: Medal, category: 'Achievement & Success' },
  { name: 'Crown', icon: Crown, category: 'Achievement & Success' },
  { name: 'Flag', icon: Flag, category: 'Achievement & Success' },
  { name: 'Zap', icon: Zap, category: 'Achievement & Success' },
  { name: 'Flame', icon: Flame, category: 'Achievement & Success' },
  { name: 'Sparkles', icon: Sparkles, category: 'Achievement & Success' },

  // Technology & Devices
  { name: 'Laptop', icon: Laptop, category: 'Technology & Devices' },
  { name: 'Monitor', icon: Monitor, category: 'Technology & Devices' },
  { name: 'Smartphone', icon: Smartphone, category: 'Technology & Devices' },
  { name: 'Tablet', icon: Tablet, category: 'Technology & Devices' },
  { name: 'Database', icon: Database, category: 'Technology & Devices' },
  { name: 'Server', icon: Server, category: 'Technology & Devices' },
  { name: 'Cloud', icon: Cloud, category: 'Technology & Devices' },
  { name: 'Hard Drive', icon: HardDrive, category: 'Technology & Devices' },
  { name: 'CPU', icon: Cpu, category: 'Technology & Devices' },
  { name: 'Wifi', icon: Wifi, category: 'Technology & Devices' },
  { name: 'Radio', icon: Radio, category: 'Technology & Devices' },
  { name: 'Bluetooth', icon: Bluetooth, category: 'Technology & Devices' },
  { name: 'Printer', icon: Printer, category: 'Technology & Devices' },
  { name: 'Scan', icon: Scan, category: 'Technology & Devices' },
  { name: 'QR Code', icon: QrCode, category: 'Technology & Devices' },
  { name: 'Barcode', icon: Barcode, category: 'Technology & Devices' },
  { name: 'Battery', icon: Battery, category: 'Technology & Devices' },
  { name: 'Battery Charging', icon: BatteryCharging, category: 'Technology & Devices' },
  { name: 'Plug', icon: Plug, category: 'Technology & Devices' },
  { name: 'Power', icon: Power, category: 'Technology & Devices' },
  { name: 'Power Off', icon: PowerOff, category: 'Technology & Devices' },

  // Communication
  { name: 'Mail', icon: Mail, category: 'Communication' },
  { name: 'Send', icon: Send, category: 'Communication' },
  { name: 'Message Circle', icon: MessageCircle, category: 'Communication' },
  { name: 'Message Square', icon: MessageSquare, category: 'Communication' },
  { name: 'Phone', icon: Phone, category: 'Communication' },
  { name: 'Phone Call', icon: PhoneCall, category: 'Communication' },
  { name: 'Bell', icon: Bell, category: 'Communication' },
  { name: 'At Sign', icon: AtSign, category: 'Communication' },
  { name: 'Share', icon: Share, category: 'Communication' },
  { name: 'Share 2', icon: Share2, category: 'Communication' },
  { name: 'RSS', icon: Rss, category: 'Communication' },
  { name: 'Signal', icon: Signal, category: 'Communication' },
  { name: 'Antenna', icon: Antenna, category: 'Communication' },

  // Media & Entertainment
  { name: 'Camera', icon: Camera, category: 'Media & Entertainment' },
  { name: 'Video', icon: Video, category: 'Media & Entertainment' },
  { name: 'Film', icon: Film, category: 'Media & Entertainment' },
  { name: 'Image', icon: Image, category: 'Media & Entertainment' },
  { name: 'Music', icon: Music, category: 'Media & Entertainment' },
  { name: 'Headphones', icon: Headphones, category: 'Media & Entertainment' },
  { name: 'Mic', icon: Mic, category: 'Media & Entertainment' },
  { name: 'Volume', icon: Volume, category: 'Media & Entertainment' },
  { name: 'Volume 1', icon: Volume1, category: 'Media & Entertainment' },
  { name: 'Volume 2', icon: Volume2, category: 'Media & Entertainment' },
  { name: 'Volume X', icon: VolumeX, category: 'Media & Entertainment' },
  { name: 'Play', icon: Play, category: 'Media & Entertainment' },
  { name: 'Pause', icon: Pause, category: 'Media & Entertainment' },
  { name: 'Skip Back', icon: SkipBack, category: 'Media & Entertainment' },
  { name: 'Skip Forward', icon: SkipForward, category: 'Media & Entertainment' },
  { name: 'Fast Forward', icon: FastForward, category: 'Media & Entertainment' },
  { name: 'Rewind', icon: Rewind, category: 'Media & Entertainment' },
  { name: 'Repeat', icon: Repeat, category: 'Media & Entertainment' },
  { name: 'Shuffle', icon: Shuffle, category: 'Media & Entertainment' },
  { name: 'TV', icon: Tv, category: 'Media & Entertainment' },
  { name: 'Gamepad', icon: Gamepad, category: 'Media & Entertainment' },
  { name: 'Gamepad 2', icon: Gamepad2, category: 'Media & Entertainment' },

  // Files & Documents
  { name: 'File', icon: File, category: 'Files & Documents' },
  { name: 'File Text', icon: FileText, category: 'Files & Documents' },
  { name: 'Folder', icon: Folder, category: 'Files & Documents' },
  { name: 'Folder Open', icon: FolderOpen, category: 'Files & Documents' },
  { name: 'Bookmark', icon: Bookmark, category: 'Files & Documents' },
  { name: 'Tag', icon: Tag, category: 'Files & Documents' },
  { name: 'Hash', icon: Hash, category: 'Files & Documents' },
  { name: 'Clipboard', icon: Clipboard, category: 'Files & Documents' },
  { name: 'Copy', icon: Copy, category: 'Files & Documents' },
  { name: 'Scissors', icon: Scissors, category: 'Files & Documents' },
  { name: 'Save', icon: Save, category: 'Files & Documents' },
  { name: 'Download', icon: Download, category: 'Files & Documents' },
  { name: 'Upload', icon: Upload, category: 'Files & Documents' },

  // Navigation & Location
  { name: 'Compass', icon: Compass, category: 'Navigation & Location' },
  { name: 'Map', icon: Map, category: 'Navigation & Location' },
  { name: 'Map Pin', icon: MapPin, category: 'Navigation & Location' },
  { name: 'Globe', icon: Globe, category: 'Navigation & Location' },
  { name: 'Navigation', icon: Navigation, category: 'Navigation & Location' },
  { name: 'Navigation 2', icon: Navigation2, category: 'Navigation & Location' },
  { name: 'Locate', icon: Locate, category: 'Navigation & Location' },
  { name: 'Crosshair', icon: Crosshair, category: 'Navigation & Location' },
  { name: 'Anchor', icon: Anchor, category: 'Navigation & Location' },
  { name: 'Home', icon: Home, category: 'Navigation & Location' },

  // Time & Calendar
  { name: 'Calendar', icon: Calendar, category: 'Time & Calendar' },
  { name: 'Clock', icon: Clock, category: 'Time & Calendar' },
  { name: 'Timer', icon: Timer, category: 'Time & Calendar' },
  { name: 'Hourglass', icon: Hourglass, category: 'Time & Calendar' },
  { name: 'Watch', icon: Watch, category: 'Time & Calendar' },
  { name: 'Alarm Clock', icon: AlarmClock, category: 'Time & Calendar' },

  // Charts & Analytics
  { name: 'Activity', icon: Activity, category: 'Charts & Analytics' },
  { name: 'Trending Up', icon: TrendingUp, category: 'Charts & Analytics' },
  { name: 'Trending Down', icon: TrendingDown, category: 'Charts & Analytics' },
  { name: 'Bar Chart', icon: BarChart, category: 'Charts & Analytics' },
  { name: 'Bar Chart 2', icon: BarChart2, category: 'Charts & Analytics' },
  { name: 'Bar Chart 3', icon: BarChart3, category: 'Charts & Analytics' },
  { name: 'Pie Chart', icon: PieChart, category: 'Charts & Analytics' },
  { name: 'Line Chart', icon: LineChart, category: 'Charts & Analytics' },
  { name: 'Gauge', icon: Gauge, category: 'Charts & Analytics' },

  // Design & Layout
  { name: 'Layers', icon: Layers, category: 'Design & Layout' },
  { name: 'Layout', icon: Layout, category: 'Design & Layout' },
  { name: 'Grid', icon: Grid, category: 'Design & Layout' },
  { name: 'Columns', icon: Columns, category: 'Design & Layout' },
  { name: 'Square', icon: Square, category: 'Design & Layout' },
  { name: 'Circle', icon: Circle, category: 'Design & Layout' },
  { name: 'Triangle', icon: Triangle, category: 'Design & Layout' },
  { name: 'Hexagon', icon: Hexagon, category: 'Design & Layout' },
  { name: 'Pentagon', icon: Pentagon, category: 'Design & Layout' },
  { name: 'Octagon', icon: Octagon, category: 'Design & Layout' },
  { name: 'Diamond', icon: Diamond, category: 'Design & Layout' },
  { name: 'Paintbrush', icon: Paintbrush, category: 'Design & Layout' },
  { name: 'Palette', icon: Palette, category: 'Design & Layout' },
  { name: 'Pipette', icon: Pipette, category: 'Design & Layout' },
  { name: 'Pen', icon: Pen, category: 'Design & Layout' },
  { name: 'Pen Tool', icon: PenTool, category: 'Design & Layout' },
  { name: 'Eraser', icon: Eraser, category: 'Design & Layout' },

  // Actions & Controls
  { name: 'Plus', icon: Plus, category: 'Actions & Controls' },
  { name: 'Minus', icon: Minus, category: 'Actions & Controls' },
  { name: 'X', icon: X, category: 'Actions & Controls' },
  { name: 'Check', icon: Check, category: 'Actions & Controls' },
  { name: 'Check Circle', icon: CheckCircle, category: 'Actions & Controls' },
  { name: 'X Circle', icon: XCircle, category: 'Actions & Controls' },
  { name: 'Search', icon: Search, category: 'Actions & Controls' },
  { name: 'Filter', icon: Filter, category: 'Actions & Controls' },
  { name: 'Sliders', icon: Sliders, category: 'Actions & Controls' },
  { name: 'Sliders Horizontal', icon: SlidersHorizontal, category: 'Actions & Controls' },
  { name: 'Edit', icon: Edit, category: 'Actions & Controls' },
  { name: 'Edit 2', icon: Edit2, category: 'Actions & Controls' },
  { name: 'Edit 3', icon: Edit3, category: 'Actions & Controls' },
  { name: 'Trash', icon: Trash, category: 'Actions & Controls' },
  { name: 'Trash 2', icon: Trash2, category: 'Actions & Controls' },
  { name: 'Maximize', icon: Maximize, category: 'Actions & Controls' },
  { name: 'Minimize', icon: Minimize, category: 'Actions & Controls' },
  { name: 'Maximize 2', icon: Maximize2, category: 'Actions & Controls' },
  { name: 'Minimize 2', icon: Minimize2, category: 'Actions & Controls' },
  { name: 'Zoom In', icon: ZoomIn, category: 'Actions & Controls' },
  { name: 'Zoom Out', icon: ZoomOut, category: 'Actions & Controls' },
  { name: 'Move', icon: Move, category: 'Actions & Controls' },
  { name: 'Toggle Left', icon: ToggleLeft, category: 'Actions & Controls' },
  { name: 'Toggle Right', icon: ToggleRight, category: 'Actions & Controls' },

  // Alerts & Status
  { name: 'Alert Circle', icon: AlertCircle, category: 'Alerts & Status' },
  { name: 'Alert Triangle', icon: AlertTriangle, category: 'Alerts & Status' },
  { name: 'Info', icon: Info, category: 'Alerts & Status' },
  { name: 'Help Circle', icon: HelpCircle, category: 'Alerts & Status' },

  // Nature & Weather
  { name: 'Sun', icon: Sun, category: 'Nature & Weather' },
  { name: 'Moon', icon: Moon, category: 'Nature & Weather' },
  { name: 'Cloud Rain', icon: CloudRain, category: 'Nature & Weather' },
  { name: 'Cloud Snow', icon: CloudSnow, category: 'Nature & Weather' },
  { name: 'Cloud Drizzle', icon: CloudDrizzle, category: 'Nature & Weather' },
  { name: 'Cloud Lightning', icon: CloudLightning, category: 'Nature & Weather' },
  { name: 'Wind', icon: Wind, category: 'Nature & Weather' },
  { name: 'Umbrella', icon: Umbrella, category: 'Nature & Weather' },
  { name: 'Snowflake', icon: Snowflake, category: 'Nature & Weather' },
  { name: 'Droplet', icon: Droplet, category: 'Nature & Weather' },
  { name: 'Droplets', icon: Droplets, category: 'Nature & Weather' },
  { name: 'Sunrise', icon: Sunrise, category: 'Nature & Weather' },
  { name: 'Sunset', icon: Sunset, category: 'Nature & Weather' },
  { name: 'Mountain', icon: Mountain, category: 'Nature & Weather' },
  { name: 'Tree Pine', icon: TreePine, category: 'Nature & Weather' },
  { name: 'Flower', icon: Flower, category: 'Nature & Weather' },
  { name: 'Leaf', icon: Leaf, category: 'Nature & Weather' },
  { name: 'Feather', icon: Feather, category: 'Nature & Weather' },

  // Transportation
  { name: 'Plane', icon: Plane, category: 'Transportation' },
  { name: 'Car', icon: Car, category: 'Transportation' },
  { name: 'Bike', icon: Bike, category: 'Transportation' },
  { name: 'Bus', icon: Bus, category: 'Transportation' },
  { name: 'Train', icon: Train, category: 'Transportation' },
  { name: 'Truck', icon: Truck, category: 'Transportation' },
  { name: 'Ship', icon: Ship, category: 'Transportation' },

  // Science & Medical
  { name: 'Atom', icon: Atom, category: 'Science & Medical' },
  { name: 'DNA', icon: Dna, category: 'Science & Medical' },
  { name: 'Microscope', icon: Microscope, category: 'Science & Medical' },
  { name: 'Test Tube', icon: TestTube, category: 'Science & Medical' },
  { name: 'Beaker', icon: Beaker, category: 'Science & Medical' },
  { name: 'Pill', icon: Pill, category: 'Science & Medical' },
  { name: 'Syringe', icon: Syringe, category: 'Science & Medical' },
  { name: 'Stethoscope', icon: Stethoscope, category: 'Science & Medical' },
  { name: 'Bandage', icon: Bandage, category: 'Science & Medical' },
  { name: 'Heart Pulse', icon: HeartPulse, category: 'Science & Medical' },
  { name: 'Brain', icon: Brain, category: 'Science & Medical' },
  { name: 'Bone', icon: Bone, category: 'Science & Medical' },
  { name: 'Thermometer', icon: Thermometer, category: 'Science & Medical' },

  // Food & Drink
  { name: 'Coffee', icon: Coffee, category: 'Food & Drink' },
  { name: 'Beer', icon: Beer, category: 'Food & Drink' },
  { name: 'Wine', icon: Wine, category: 'Food & Drink' },
  { name: 'Pizza', icon: Pizza, category: 'Food & Drink' },
  { name: 'Cake', icon: Cake, category: 'Food & Drink' },
  { name: 'Cookie', icon: Cookie, category: 'Food & Drink' },
  { name: 'Apple', icon: Apple, category: 'Food & Drink' },
  { name: 'Cherry', icon: Cherry, category: 'Food & Drink' },
  { name: 'Grape', icon: Grape, category: 'Food & Drink' },
  { name: 'Banana', icon: Banana, category: 'Food & Drink' },
  { name: 'Carrot', icon: Carrot, category: 'Food & Drink' },
  { name: 'Egg', icon: Egg, category: 'Food & Drink' },
  { name: 'Fish', icon: Fish, category: 'Food & Drink' },
  { name: 'Beef', icon: Beef, category: 'Food & Drink' },
  { name: 'Soup', icon: Soup, category: 'Food & Drink' },
  { name: 'Utensils', icon: Utensils, category: 'Food & Drink' },
  { name: 'Utensils Crossed', icon: UtensilsCrossed, category: 'Food & Drink' },
  { name: 'Chef Hat', icon: ChefHat, category: 'Food & Drink' },

  // Home & Living
  { name: 'Lamp', icon: Lamp, category: 'Home & Living' },
  { name: 'Lightbulb', icon: Lightbulb, category: 'Home & Living' },
  { name: 'Flashlight', icon: Flashlight, category: 'Home & Living' },
  { name: 'Sofa', icon: Sofa, category: 'Home & Living' },
  { name: 'Bed', icon: Bed, category: 'Home & Living' },
  { name: 'Bath', icon: Bath, category: 'Home & Living' },

  // Fashion & Accessories
  { name: 'Shirt', icon: Shirt, category: 'Fashion & Accessories' },
  { name: 'Glasses', icon: Glasses, category: 'Fashion & Accessories' },
  { name: 'Gem', icon: Gem, category: 'Fashion & Accessories' },

  // Fun & Games
  { name: 'Heart', icon: Heart, category: 'Fun & Games' },
  { name: 'Thumbs Up', icon: ThumbsUp, category: 'Fun & Games' },
  { name: 'Thumbs Down', icon: ThumbsDown, category: 'Fun & Games' },
  { name: 'Smile', icon: Smile, category: 'Fun & Games' },
  { name: 'Frown', icon: Frown, category: 'Fun & Games' },
  { name: 'Meh', icon: Meh, category: 'Fun & Games' },
  { name: 'Gift', icon: Gift, category: 'Fun & Games' },
  { name: 'Party Popper', icon: PartyPopper, category: 'Fun & Games' },
  { name: 'Sparkle', icon: Sparkle, category: 'Fun & Games' },
  { name: 'Wand', icon: Wand, category: 'Fun & Games' },
  { name: 'Wand 2', icon: Wand2, category: 'Fun & Games' },
  { name: 'Dice 1', icon: Dice1, category: 'Fun & Games' },
  { name: 'Dice 2', icon: Dice2, category: 'Fun & Games' },
  { name: 'Dice 3', icon: Dice3, category: 'Fun & Games' },
  { name: 'Dice 4', icon: Dice4, category: 'Fun & Games' },
  { name: 'Dice 5', icon: Dice5, category: 'Fun & Games' },
  { name: 'Dice 6', icon: Dice6, category: 'Fun & Games' },
  { name: 'Puzzle', icon: Puzzle, category: 'Fun & Games' },
  { name: 'Bug', icon: Bug, category: 'Fun & Games' },
  { name: 'Skull', icon: Skull, category: 'Fun & Games' },
  { name: 'Spade', icon: Spade, category: 'Fun & Games' },
  { name: 'Club', icon: Club, category: 'Fun & Games' },

  // Arrows & Directions
  { name: 'Arrow Up', icon: ArrowUp, category: 'Arrows & Directions' },
  { name: 'Arrow Down', icon: ArrowDown, category: 'Arrows & Directions' },
  { name: 'Arrow Left', icon: ArrowLeft, category: 'Arrows & Directions' },
  { name: 'Arrow Right', icon: ArrowRight, category: 'Arrows & Directions' },
  { name: 'Chevron Up', icon: ChevronUp, category: 'Arrows & Directions' },
  { name: 'Chevron Down', icon: ChevronDown, category: 'Arrows & Directions' },
  { name: 'Chevron Left', icon: ChevronLeft, category: 'Arrows & Directions' },
  { name: 'Chevron Right', icon: ChevronRight, category: 'Arrows & Directions' },
  { name: 'Chevrons Up', icon: ChevronsUp, category: 'Arrows & Directions' },
  { name: 'Chevrons Down', icon: ChevronsDown, category: 'Arrows & Directions' },
  { name: 'Chevrons Left', icon: ChevronsLeft, category: 'Arrows & Directions' },
  { name: 'Chevrons Right', icon: ChevronsRight, category: 'Arrows & Directions' },
  { name: 'Corner Up Left', icon: CornerUpLeft, category: 'Arrows & Directions' },
  { name: 'Corner Up Right', icon: CornerUpRight, category: 'Arrows & Directions' },
  { name: 'Corner Down Left', icon: CornerDownLeft, category: 'Arrows & Directions' },
  { name: 'Corner Down Right', icon: CornerDownRight, category: 'Arrows & Directions' },

  // Menu & Navigation
  { name: 'Menu', icon: Menu, category: 'Menu & Navigation' },
  { name: 'More Horizontal', icon: MoreHorizontal, category: 'Menu & Navigation' },
  { name: 'More Vertical', icon: MoreVertical, category: 'Menu & Navigation' },
  { name: 'Grip', icon: Grip, category: 'Menu & Navigation' },
  { name: 'Grip Vertical', icon: GripVertical, category: 'Menu & Navigation' },
  { name: 'Link', icon: Link, category: 'Menu & Navigation' },
  { name: 'Link 2', icon: Link2, category: 'Menu & Navigation' },
  { name: 'External Link', icon: ExternalLink, category: 'Menu & Navigation' },

  // Text Formatting
  { name: 'Type', icon: Type, category: 'Text Formatting' },
  { name: 'Bold', icon: Bold, category: 'Text Formatting' },
  { name: 'Italic', icon: Italic, category: 'Text Formatting' },
  { name: 'Underline', icon: Underline, category: 'Text Formatting' },
  { name: 'Align Left', icon: AlignLeft, category: 'Text Formatting' },
  { name: 'Align Center', icon: AlignCenter, category: 'Text Formatting' },
  { name: 'Align Right', icon: AlignRight, category: 'Text Formatting' },
  { name: 'Align Justify', icon: AlignJustify, category: 'Text Formatting' },
  { name: 'List', icon: List, category: 'Text Formatting' },
  { name: 'List Ordered', icon: ListOrdered, category: 'Text Formatting' },
  { name: 'Indent', icon: Indent, category: 'Text Formatting' },
  { name: 'Outdent', icon: Outdent, category: 'Text Formatting' },
  { name: 'Quote', icon: Quote, category: 'Text Formatting' },

  // Miscellaneous
  { name: 'Aperture', icon: Aperture, category: 'Miscellaneous' },
  { name: 'Focus', icon: Focus, category: 'Miscellaneous' },
  { name: 'Disc', icon: Disc, category: 'Miscellaneous' },
  { name: 'Ruler', icon: Ruler, category: 'Miscellaneous' },
  { name: 'Orbit', icon: Orbit, category: 'Miscellaneous' },
  { name: 'Radar', icon: Radar, category: 'Miscellaneous' },
  { name: 'Waves', icon: Waves, category: 'Miscellaneous' },
  { name: 'Fan', icon: Fan, category: 'Miscellaneous' },
  { name: 'Network', icon: Network, category: 'Miscellaneous' },
];

export const ICON_CATEGORIES = Array.from(
  new Set(TEAM_ICONS.map((icon) => icon.category))
).sort((a, b) => a.localeCompare(b));

// Create a lookup object for quick icon access by name
export const TEAM_ICONS_MAP: Record<string, LucideIcon> = TEAM_ICONS.reduce(
  (acc, icon) => {
    acc[icon.name] = icon.icon;
    return acc;
  },
  {} as Record<string, LucideIcon>
);

export const getIconByName = (name: string): LucideIcon | undefined => {
  return TEAM_ICONS.find((icon) => icon.name === name)?.icon;
};

export const getRandomIcon = (): TeamIcon => {
  return TEAM_ICONS[Math.floor(Math.random() * TEAM_ICONS.length)];
};
